import type { ReactNode } from 'react';
import { Flex } from 'antd';
import {
  BracketsSquareIcon,
  CircleIcon,
  HighlighterIcon,
  SquareIcon,
  TextStrikethroughIcon,
  TextUnderlineIcon,
  XIcon,
} from '@phosphor-icons/react';
import { colors, radii } from '../../../../theme-v2';
import type { StandoutNotation } from './types';

/**
 * Which icon stands for each notation, so a row's icon reads as the mark it
 * leaves on the document. Lives here rather than in the marker table to keep
 * that module JSX-free.
 */
export const STANDOUT_NOTATION_ICON: Record<StandoutNotation, ReactNode> = {
  highlight: <HighlighterIcon size={14} weight="bold" />,
  circle: <CircleIcon size={14} weight="bold" />,
  box: <SquareIcon size={14} weight="bold" />,
  underline: <TextUnderlineIcon size={14} weight="bold" />,
  'strike-through': <TextStrikethroughIcon size={14} weight="bold" />,
  bracket: <BracketsSquareIcon size={14} weight="bold" />,
  'crossed-off': <XIcon size={14} weight="bold" />,
};

export type StandoutNotationSwatchProps = {
  notation: StandoutNotation;
  /** The standout's marker color, filling the swatch. */
  color: string;
  /** Diameter in px. */
  size?: number;
};

/** Round swatch tinted per standout, holding its notation icon. Decorative. */
export const StandoutNotationSwatch = ({
  notation,
  color,
  size = 26,
}: StandoutNotationSwatchProps) => (
  <Flex
    align="center"
    justify="center"
    aria-hidden
    style={{
      width: size,
      height: size,
      flexShrink: 0,
      borderRadius: radii.full,
      background: color,
      color: colors.text.onAccent,
    }}
  >
    {STANDOUT_NOTATION_ICON[notation]}
  </Flex>
);

export default StandoutNotationSwatch;
